module.exports = __webpack_public_path__ + "static/Grafika3-b32281ef744626d0cfb8eb81b352c36c.png";